import {convertAllUmlats, hasInvalidCharOrUmlat, isAllowChar, normalizeText, removeCyrillic} from 'tfx-common/api/functions'
import {showTimedTooltip} from '@/common/api/tooltips'

document.addEventListener('trix-before-initialize', event => {
  const nonCyrillic = event.target.dataset.allowedChars === 'non-cyrillic'

  event.target.addEventListener('paste', e => {
    const clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData
    const realValue = clipboardData.getData('text')
    if (hasInvalidCharOrUmlat(realValue)) {
      const newValue = nonCyrillic ? removeCyrillic(realValue) : convertAllUmlats(normalizeText(realValue))
      if (realValue !== newValue) {
        // e.dataValue = newValue
        const cke = e.target.closest('trix-editor')
        cke.editor.insertHTML(newValue)
        e.preventDefault()
        e.stopPropagation()

        // eslint-disable-next-line no-multi-str
        const text = 'Oh-oh. It looks like you used a non-English character. \
          Unfortunately IRS only accepts English characters, so we had to remove all symbols that don\'t comply with IRS \
          rules and replace them with English equivalents.'
        if (!backtickTest(realValue, newValue)) {
          showTimedTooltip(cke, text, 'only-latin-char')
        }
      }
    }
  })

  event.target.addEventListener('keydown', e => {
    const disallowed = nonCyrillic ? /[а-яА-ЯёЁ]/g.test(e.key) : !isAllowChar(e.key)
    if (disallowed) {
      const cke = e.target
      showTimedTooltip(cke, 'You entered invalid character.', 'only-latin-char')
      e.preventDefault()
    }
  })
})

const backtickTest = function(text, filtered) {
  const replaced = text.replace(/�/g, '\'')
  return (filtered === replaced)
}
// воадлвыфоадлвыаовыфда выадлоыфвдлаоывадлыфоlksdjflsdjfwejoifjewoif
